// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__31n4p","header":"Messages_header__2ZlLT"};